import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import classNames from "classnames";
import React, { FC } from "react";

import i18n, { LANGUAGES } from "../../i18n";
import Condition from "../Conditional/Condition";
import { Button } from "../elements";
import "./LanguageSelect.scss";

interface ILanguageSelectProps {
	onClick: () => void;
	"data-testid"?: string;
	className?: string;
	hideLanguageSelect?: boolean;
}

const LanguageSelect: FC<ILanguageSelectProps> = (props) => {
	const handleClick = () => {
		props.onClick();
	};

	return (
		<Condition
			check={props.hideLanguageSelect}
			failDisplay={
				<Button
					onClick={handleClick}
					data-testid={props["data-testid"] ?? "LanguageSelect"}
					variant="text"
					className={classNames(props.className, "LanguageSelect")}
					color="inherit"
				>
					{LANGUAGES.find((lang) => lang.value === i18n.language)?.label}
					<KeyboardArrowDownIcon />
				</Button>
			}
		>
			<div className="LanguageSelectPlaceHolder" />
		</Condition>
	);
};

export default LanguageSelect;
